import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { useState } from 'react';
import { connect } from 'react-redux';
import Link from 'next/link';
import { classnames } from '@@client/lib/classes';
import Authenticated from '@@client/auth/Authenticated';
import NotAuthenticated from '@@client/auth/NotAuthenticated';
import LoginModal from '@@client/account/login/LoginModal';
import RegisterModal from '@@client/account/register/RegisterModal';
import RecoverPasswordModal from '@@client/account/recover/RecoverPasswordModal';
import CartIcon from '@@client/cart/CartIcon'; // eslint-disable-next-line no-unused-vars

var MyGarageIcon = function MyGarageIcon(_ref) {
  var _ref$isCurrent = _ref.isCurrent,
      isCurrent = _ref$isCurrent === void 0 ? false : _ref$isCurrent,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? '/account/my-garage' : _ref$href,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'My Garage' : _ref$label;
  var classNames = classnames(['my-garage', isCurrent ? 'is-current' : 'not-current']);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Link, {
      href: href,
      children: /*#__PURE__*/_jsx("a", {
        "aria-label": label,
        className: "jsx-3969483694" + " " + (classNames || ""),
        children: /*#__PURE__*/_jsx("div", {
          className: "jsx-3969483694" + " " + 'icon'
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "jsx-3969483694" + " " + 'preload01'
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "3969483694",
      children: [".preload01.jsx-3969483694{background:transparent url('/images/icons/icon-nav-garage-on.svg') no-repeat;}", ".my-garage.jsx-3969483694{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%;height:100%;}", ".my-garage.is-current.jsx-3969483694,.my-garage.jsx-3969483694:hover{background:#21409A;}", ".my-garage.is-current.jsx-3969483694 .icon.jsx-3969483694,.my-garage.jsx-3969483694:hover .icon.jsx-3969483694{background-image:url('/images/icons/icon-nav-garage-on.svg');}", ".icon.jsx-3969483694{display:block;width:33px;height:25px;background:transparent url('/images/icons/icon-nav-garage-off.svg') no-repeat;background-size:100% 100%;}"]
    })]
  });
};

var MyAccountIcon = function MyAccountIcon(_ref2) {
  var _ref2$isCurrent = _ref2.isCurrent,
      isCurrent = _ref2$isCurrent === void 0 ? false : _ref2$isCurrent,
      _ref2$href = _ref2.href,
      href = _ref2$href === void 0 ? '/account' : _ref2$href,
      _ref2$label = _ref2.label,
      label = _ref2$label === void 0 ? 'My Account' : _ref2$label;
  var classNames = classnames(['my-account', isCurrent ? 'is-current' : 'not-current']);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Link, {
      href: href,
      children: /*#__PURE__*/_jsx("a", {
        "aria-label": label,
        className: "jsx-3924573538" + " " + (classNames || ""),
        children: /*#__PURE__*/_jsx("span", {
          className: "jsx-3924573538" + " " + 'icon'
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "jsx-3924573538" + " " + 'preload01'
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "3924573538",
      children: [".preload01.jsx-3924573538{background:transparent url('/images/icons/icon-nav-account-on.svg') no-repeat;}", ".my-account.jsx-3924573538{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%;height:100%;}", ".my-account.is-current.jsx-3924573538,.my-account.jsx-3924573538:hover{background:#21409A;}", ".my-account.is-current.jsx-3924573538 .icon.jsx-3924573538,.my-account.jsx-3924573538:hover .icon.jsx-3924573538{background-image:url('/images/icons/icon-nav-account-on.svg');}", ".icon.jsx-3924573538{display:block;width:24px;height:26px;background:transparent url('/images/icons/icon-nav-account-off.svg') no-repeat;background-size:100% 100%;}"]
    })]
  });
};

var mapStateToProps = function mapStateToProps(_ref3) {
  var chat = _ref3.chat,
      config = _ref3.config;
  return {
    chat: chat,
    config: config
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {};
};

var NavUtility = function NavUtility(_ref4) {
  var chat = _ref4.chat,
      config = _ref4.config;

  var _useState = useState(null),
      shownModal = _useState[0],
      setShownModal = _useState[1];

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(LoginModal, {
      isOpen: shownModal === 'login',
      onClose: function onClose() {
        return setShownModal(null);
      },
      onRegisterClick: function onRegisterClick() {
        return setShownModal('register');
      },
      onRecoverClick: function onRecoverClick() {
        return setShownModal('recover');
      }
    }), /*#__PURE__*/_jsx(RegisterModal, {
      isOpen: shownModal === 'register',
      onClose: function onClose() {
        return setShownModal(false);
      },
      onLoginClick: function onLoginClick() {
        return setShownModal('login');
      }
    }), /*#__PURE__*/_jsx(RecoverPasswordModal, {
      isOpen: shownModal === 'recover',
      onClose: function onClose() {
        return setShownModal(false);
      },
      onLoginClick: function onLoginClick() {
        return setShownModal('login');
      }
    }), /*#__PURE__*/_jsx("nav", {
      "aria-label": "Utility navigation",
      className: "jsx-1896548358",
      children: /*#__PURE__*/_jsxs("ul", {
        className: "jsx-1896548358",
        children: [/*#__PURE__*/_jsx("li", {
          className: "jsx-1896548358" + " " + 'tel',
          children: /*#__PURE__*/_jsx("a", {
            href: "tel:".concat(config.contact.phoneFull),
            className: "jsx-1896548358" + " " + 'text-link',
            children: config.contact.phoneHuman
          })
        }), chat.isAvailable ? /*#__PURE__*/_jsx("li", {
          className: "jsx-1896548358" + " " + 'chat',
          children: /*#__PURE__*/_jsx("button", {
            className: "jsx-1896548358" + " " + 'text-link m--as-link',
            children: "Live Chat"
          })
        }) : null, /*#__PURE__*/_jsx(NotAuthenticated, {
          children: /*#__PURE__*/_jsx("li", {
            className: "jsx-1896548358" + " " + 'sep',
            children: /*#__PURE__*/_jsx("button", {
              onClick: function onClick() {
                return setShownModal('login');
              },
              className: "jsx-1896548358" + " " + 'text-link m--as-link',
              children: "Log In"
            })
          })
        }), /*#__PURE__*/_jsx(Authenticated, {
          children: /*#__PURE__*/_jsx("li", {
            className: "jsx-1896548358" + " " + 'sep',
            children: /*#__PURE__*/_jsx(MyAccountIcon, {})
          })
        }), /*#__PURE__*/_jsx("li", {
          className: "jsx-1896548358" + " " + 'sep',
          children: /*#__PURE__*/_jsx(CartIcon, {})
        })]
      })
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1896548358",
      children: ["nav.jsx-1896548358{background:-webkit-gradient(linear,left top,left bottom,from(rgba(134,148,184,0.84)),color-stop(33%,#F0F1F3));background:linear-gradient(rgba(134,148,184,0.84) 0%,#F0F1F3 33%);border-top:4px solid white;border-bottom:4px solid white;}", ".m--as-link.jsx-1896548358,a.jsx-1896548358{-webkit-text-decoration:none;text-decoration:none;color:#21409A;}", ".m--as-link.jsx-1896548358:hover,a.jsx-1896548358:hover{color:#468EE5;}", "ul.jsx-1896548358{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;list-style:none;text-align:right;margin:0;padding:0 0 0 calc(var(--headerLogoWidth) + var(--headerLogoOffsetLeft) + var(--headerLogoPaddingLeft));}", "li.jsx-1896548358{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-width:95px;}", "@media(max-width:910px){li.jsx-1896548358{display:none;}li.tel.jsx-1896548358{display:block;}}", "li.jsx-1896548358 a,li.jsx-1896548358 button.m--as-link{display:block;padding-left:25px;padding-right:25px;}", "@media(max-width:910px){li.jsx-1896548358 a,li.jsx-1896548358 button.m--as-link{padding-left:10px;padding-right:10px;}}", "li.jsx-1896548358 .text-link.jsx-1896548358{padding-top:8px;padding-bottom:8px;}", "@media(max-width:504px){li.jsx-1896548358 .text-link.jsx-1896548358{padding-top:3px;padding-bottom:3px;}}", "li.sep.jsx-1896548358{border-left:5px solid white;}", "li.sep.jsx-1896548358 a.jsx-1896548358,li.sep.jsx-1896548358 .m--as-link.jsx-1896548358{height:100%;}", "li.sep.jsx-1896548358 a.jsx-1896548358:hover,li.sep.jsx-1896548358 .m--as-link.jsx-1896548358:hover{background:#21409A;color:white;}", "li.chat.jsx-1896548358{position:relative;}", "li.chat.jsx-1896548358::after{content:'';display:block;position:absolute;left:0;top:calc(50% - 10px);height:20px;width:2px;background:#21409A;}"]
    })]
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(NavUtility);